import useCommitments from './useCommitments';

const useCommitment = (id?: string) => {
  const { commitments } = useCommitments();
  if (!id) {
    return undefined;
  }
  return commitments.find((c) => c.id === id);
};

export default useCommitment;
